import { FunctionComponent } from "react";

import { Modal } from "@/components";
import { Checkbox } from "@/components/Checkbox/Checkbox";

import { User } from "@/pages/Public/pages/Login/schema/login";

import { Sender } from "../../../../List/components/CampaignOverview/components/Sender";
import { SendersInfo } from "../../../../List/components/CampaignOverview/components/Lead/components/SendersInfo";

interface ConfirmScheduleSequencesModalProps {
	/** How many leads are about to be sent out. */
	count: number;
	configureSenders: boolean;
	onToggleConfigureSenders: () => void;
	senders: Sender[];
	sendingUsers: User[];
	setSenders: (senders: Sender[]) => void;
	onClose: () => void;
	onConfirm: () => void;
}

/** Compose's "Send Selected" confirmation, with the optional sender override. */
export const ConfirmScheduleSequencesModal: FunctionComponent<
	ConfirmScheduleSequencesModalProps
> = ({
	count,
	configureSenders,
	onToggleConfigureSenders,
	senders,
	sendingUsers,
	setSenders,
	onClose,
	onConfirm,
}) => (
	<Modal
		isOpened
		handleClose={onClose}
		handleSave={onConfirm}
		size="md"
		submitButtonText="Send"
		title="Send"
	>
		<div className="flex flex-col gap-4">
			<div className="flex flex-col gap-2">
				<div className="flex flex-col gap-2">
					Are you sure you want to schedule{" "}
					{count > 1 ? `these ${count} sequences` : "this sequence"}?
					<div className="flex flex-col gap-2 mt-4 text-sm text-text-meta">
						You can configure who is sending this sequence.
					</div>
					<Checkbox isChecked={configureSenders} onChange={onToggleConfigureSenders}>
						Defining who is sending this sequence
					</Checkbox>
					{configureSenders && (
						<SendersInfo senders={senders} sendingUsers={sendingUsers} setSenders={setSenders} />
					)}
				</div>
			</div>
		</div>
	</Modal>
);
